var i=(l=>(l.trivia="trivia",l.poll="poll",l))(i||{});export{i as PollTypeEnum};
